module.exports = __webpack_public_path__ + "static/media/icon-bell.7dad3cbe.svg";